// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast-root {
  position: fixed;
  left: 50%;
  bottom: 24px;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
  z-index: 999;
  pointer-events: none;
}

.toast {
  min-width: 280px;
  max-width: 360px;
  background: var(--color-bg-surface);
  color: var(--color-text-primary);
  border: 1px solid var(--color-border-default);
  border-radius: var(--radius-md);
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-md);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);
  pointer-events: auto;
  opacity: 0;
  transform: translateY(8px);
  animation: toast-in 160ms ease-out forwards;
}

.toast__message {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: inherit;
}

.toast__action {
  border: none;
  background: transparent;
  color: var(--color-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  cursor: pointer;
  padding: 4px 6px;
  border-radius: var(--radius-sm);
  transition: background-color var(--transition-fast);
}

.toast__action:hover {
  background: var(--color-bg-hover);
}

.toast--success {
  border-color: var(--color-success, #22c55e);
}

.toast--error {
  border-color: var(--color-danger, #ef4444);
}

.toast--hide {
  opacity: 0;
  transform: translateY(8px);
  transition: opacity 140ms ease-in, transform 140ms ease-in;
}

@keyframes toast-in {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/toast.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,gCAAgC;EAChC,6CAA6C;EAC7C,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,0CAA0C;EAC1C,oBAAoB;EACpB,UAAU;EACV,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;EAC3B,wCAAwC;EACxC,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,mDAAmD;AACrD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,0DAA0D;AAC5D;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".toast-root {\n  position: fixed;\n  left: 50%;\n  bottom: 24px;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n  z-index: 999;\n  pointer-events: none;\n}\n\n.toast {\n  min-width: 280px;\n  max-width: 360px;\n  background: var(--color-bg-surface);\n  color: var(--color-text-primary);\n  border: 1px solid var(--color-border-default);\n  border-radius: var(--radius-md);\n  padding: 10px 14px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-md);\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);\n  pointer-events: auto;\n  opacity: 0;\n  transform: translateY(8px);\n  animation: toast-in 160ms ease-out forwards;\n}\n\n.toast__message {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  color: inherit;\n}\n\n.toast__action {\n  border: none;\n  background: transparent;\n  color: var(--color-primary);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-sm);\n  cursor: pointer;\n  padding: 4px 6px;\n  border-radius: var(--radius-sm);\n  transition: background-color var(--transition-fast);\n}\n\n.toast__action:hover {\n  background: var(--color-bg-hover);\n}\n\n.toast--success {\n  border-color: var(--color-success, #22c55e);\n}\n\n.toast--error {\n  border-color: var(--color-danger, #ef4444);\n}\n\n.toast--hide {\n  opacity: 0;\n  transform: translateY(8px);\n  transition: opacity 140ms ease-in, transform 140ms ease-in;\n}\n\n@keyframes toast-in {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
